import { Component, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
    SimulationMappingData,
} from './data'
import { FormsModule } from '@angular/forms'
import { IsIgxDialogComponent, IsIgxHubComponent, IsIgxMappingComponent, WbsFrontend } from '@interserve/igx-angular'
import { IgxButtonModule } from '@infragistics/igniteui-angular'
import { TestdataService } from '../../services/testdata.service'
import { ShipemntRangeApiServiceApiService } from '../../api/shipment-range-api.service'
import { lastValueFrom } from 'rxjs'
import { AreaMappingHubData } from '../test/data'
import { environment } from 'src/environments/environment'

@Component({
    selector: 'is-igx-wbs-sample',
    standalone: true,
    templateUrl: './SampleTestDataWorkDate.html',
    styleUrl: './SampleTestDataWorkDate.scss',
    imports: [
        CommonModule,
        FormsModule,
        IsIgxMappingComponent,
        IsIgxHubComponent,
        IsIgxDialogComponent,
        IgxButtonModule,
    ],
})
export class SampleTestDataWorkDate {
    @ViewChild('selectDataHub', { static: true }) public selectDataHub: IsIgxHubComponent | undefined
    constructor(
        private testdataService: TestdataService,
        private shipemntRangeApiServiceApiService: ShipemntRangeApiServiceApiService
    ) {}
    loading = true
    environmentKey = environment.environmentKey
    selectedData: any = null
    StaticLeftWbsData: any[] = []
    StaticRightWbsData: any[] = []
    mappingData: WbsFrontend | undefined = undefined

    //HUB設定（紐づけで使用）
    mappingDataHub: WbsFrontend = AreaMappingHubData

    async ngOnInit(): Promise<void> {
        this.selectedData = this.testdataService.getSelectedData()
        //物流改善
        this.loading = false
        this.mappingData = SimulationMappingData
        this.StaticRightWbsData = await this.GetShipmentRangeCreateData()
        
    }
    async GetShipmentRangeCreateData(): Promise<any> {
        const fileNameList = this.selectedData.map((x: { name: string }) => x.name)
        const observable = lastValueFrom(
            this.shipemntRangeApiServiceApiService.ShipmentRangeCreate('cb910882d3944ac098de3df9a2f6e4f6', fileNameList)
        )
        const result = await observable
        return result.data
    }
}
